import "./AnimatedBackground.css"

function AnimatedBackground() {
    return (
        <aside className="animated-background"></aside>
    );
}

export default AnimatedBackground;